import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Col, Button, Form, FormGroup, Label, Input} from 'reactstrap';

import { auth } from '../firebase';

const PasswordForgetPage = () =>
    <PasswordForgetForm />


const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  error: null,
};

class PasswordForgetForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const { email } = this.state;

    auth.doPasswordReset(email)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  render() {
    const {
      email,
      error,
    } = this.state;

    const isInvalid = email === '';

    const loginStyle = {
      marginTop: 50,
      backgroundColor: "white"
    };
    const h2Style = {
      paddingLeft: 10,
      paddingTop: 5,
      fontFamily: "Audiowide, cursive",
      color: "cadetblue"
    };

    return (
    <div style={loginStyle}  className="Site_Content, container">
      <Form onSubmit={this.onSubmit}>
        <h2 style={h2Style}>Reset your Password</h2>
        <FormGroup row>
          <Label  for="email" sm={2}>New Password</Label>
          <Col sm={10}>
        <Input id="email"
          value={this.state.email}
          onChange={event => this.setState(byPropKey('email', event.target.value))}
          type="text"
          placeholder="Email Address"
        />
          </Col>
        </FormGroup>
        <Button disabled={isInvalid} type="submit">
          Reset My Password
        </Button>

        { error && <p>{error.message}</p> }
      </Form>
    </div>

    );
  }
}

const PasswordForgetLink = () =>
  <p align="center">
    <Link to="/pw-forget">Forgot Password?</Link>
  </p>

export default PasswordForgetPage;

export {
  PasswordForgetForm,
  PasswordForgetLink,
};



// WEBPACK FOOTER //
// ./src/Authentication/PasswordForget.js